import { jsxs as _, jsx as l } from "react/jsx-runtime";
import { c as m } from "./clsx-OuTLNxxd.js";
import { I as u } from "./icon-B72I4fRl.js";
import "./components/elements/icon/iconsList.js";
const d = "_callout_7jl0x_29", f = "_link_7jl0x_52", i = {
  callout: d,
  "is-full-width": "_is-full-width_7jl0x_37",
  "is-small": "_is-small_7jl0x_47",
  link: f,
  "is-medium": "_is-medium_7jl0x_55",
  "is-info": "_is-info_7jl0x_58",
  "is-warning": "_is-warning_7jl0x_61",
  "is-success": "_is-success_7jl0x_64",
  "is-error": "_is-error_7jl0x_67",
  "is-neutral": "_is-neutral_7jl0x_70",
  "is-collection": "_is-collection_7jl0x_73",
  "content-container": "_content-container_7jl0x_79",
  "dialog-overlay-show": "_dialog-overlay-show_7jl0x_1",
  "dialog-content-show": "_dialog-content-show_7jl0x_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_7jl0x_1"
}, s = {
  info: {
    name: "information-circle",
    color: "secondary"
  },
  warning: {
    name: "warning",
    color: "warning"
  },
  success: {
    name: "verification-check",
    color: "success"
  },
  error: {
    name: "notification",
    color: "error"
  },
  neutral: {
    name: "information-circle",
    color: "secondary"
  },
  collection: {
    name: "information-circle",
    color: "primary"
  }
}, x = {
  info: "is-info",
  warning: "is-warning",
  success: "is-success",
  error: "is-error",
  neutral: "is-neutral",
  collection: "is-collection"
}, j = {
  small: "is-small",
  medium: "is-medium"
};
function S({
  status: o = "info",
  size: c = "medium",
  children: r,
  hasIcon: e = !1,
  backgroundImage: n,
  isFullWidth: a = !1
}) {
  const t = m(i.callout, i[x[o]], i[j[c]], {
    [i["is-full-width"]]: a
  });
  return /* @__PURE__ */ _("div", { className: t, children: [
    e && /* @__PURE__ */ l(u, { name: s[o].name, color: s[o].color, size: "2xl" }),
    /* @__PURE__ */ l("div", { className: i["content-container"], children: r }),
    n && /* @__PURE__ */ l("img", { src: n, alt: "background" })
  ] });
}
export {
  S as C,
  s as I,
  x as a,
  j as b
};
